export default "__VITE_ASSET__412b1154__"